import {
  EXERCISE_TYPE,
  getTypeExerciseUtil
} from '../../../../exercise/model'
import hasNoWeightExerciseUtil from '../../../../exercise/model/utils/has-no-weight'
import { SET_DATA_KEY } from '../../constants'

const STRENGTH_REST_SET = {
  [SET_DATA_KEY.REST]: 60
}

const HEAVY_LIFTING_REST_SET = {
  [SET_DATA_KEY.REST]: 120
}

const CONDITIONING_SET = {
  [SET_DATA_KEY.TIME]: 40
}

const STRENGTH_SET = {
  [SET_DATA_KEY.REPS]: 8,
  [SET_DATA_KEY.WEIGHT]: 10
}

const BODYWEIGHT_SET = {
  [SET_DATA_KEY.TIME]: 40
}

const HEAVY_STRENGTH_SET = {
  [SET_DATA_KEY.REPS]: 5,
  [SET_DATA_KEY.WEIGHT]: 10
}

const CARDIO_SET = {
  [SET_DATA_KEY.TIME]: 20 * 60
}

const WARMUP_STRETCHING_SET = {
  [SET_DATA_KEY.TIME]: 20
}

const EXERCISE_TYPE_TO_SET_DATA = {
  [EXERCISE_TYPE.STRENGTH]: [
    {
      ...STRENGTH_SET
    },
    {
      ...STRENGTH_REST_SET
    }
  ],
  [EXERCISE_TYPE.PLYOMETRIC]: [
    {
      ...CONDITIONING_SET
    }
  ],
  [EXERCISE_TYPE.POWERLIFTING]: [
    {
      ...HEAVY_STRENGTH_SET
    },
    {
      ...HEAVY_LIFTING_REST_SET
    }
  ],
  [EXERCISE_TYPE.OLYMPIC_WEIGHTLIFTING]: [
    {
      ...HEAVY_STRENGTH_SET
    },
    {
      ...HEAVY_LIFTING_REST_SET
    }
  ], // [EXERCISE_TYPE.STRONGMAN]: [
  //   {
  //     ...HEAVY_STRENGTH_SET
  //   }
  // ],
  [EXERCISE_TYPE.CARDIO]: [
    {
      ...CARDIO_SET
    }
  ],
  [EXERCISE_TYPE.CONDITIONING]: [
    {
      ...CONDITIONING_SET
    }
  ],
  [EXERCISE_TYPE.STRETCHING]: [
    {
      ...WARMUP_STRETCHING_SET
    }
  ],
  [EXERCISE_TYPE.YOGA]: [
    {
      ...WARMUP_STRETCHING_SET
    }
  ],
  [EXERCISE_TYPE.BALANCE]: [
    {
      ...WARMUP_STRETCHING_SET
    }
  ], // [EXERCISE_TYPE.ACTIVATION]: [
  //   {
  //     ...WARMUP_STRETCHING_SET_DATA
  //   }
  // ],
  [EXERCISE_TYPE.SMR]: [
    {
      ...WARMUP_STRETCHING_SET
    }
  ],
  [EXERCISE_TYPE.WARMUP]: [
    {
      ...WARMUP_STRETCHING_SET
    }
  ],
  [EXERCISE_TYPE.ACTIVITY]: [
    {
      ...CARDIO_SET
    }
  ]
}

export function createFromExerciseTypeSetDataUtil (params) {
  const {
    exercise,
    weightUnit
  } = params

  const exerciseType = (
    getTypeExerciseUtil(exercise)
  )

  const initialSetData = (
    EXERCISE_TYPE_TO_SET_DATA[exerciseType] ||
    EXERCISE_TYPE_TO_SET_DATA[EXERCISE_TYPE.WARMUP] ||
    []
  )

  const setData = []

  initialSetData.forEach(set => {
    if (hasNoWeightExerciseUtil(exercise) && set[SET_DATA_KEY.REPS] != null) {
      setData.push({ ...BODYWEIGHT_SET })
      return
    }
    if (hasNoWeightExerciseUtil(exercise) && set[SET_DATA_KEY.REST] != null) {
      return
    }

    if (set[SET_DATA_KEY.WEIGHT] != null) {
      setData.push({
        ...set,
        [SET_DATA_KEY.WEIGHT_UNIT]: weightUnit
      })
      return
    }

    setData.push({ ...set })
  })

  return setData
}
